import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "radio-button" }
const _hoisted_2 = ["id", "value", "onKeyup", "onClick", "checked", "required", "name"]
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "radio-buttons__error" }

import { Ref, ref, watch } from 'vue';


export interface IDmComponentsItem {
  key: string | number;
  text: string;
}

interface IProps {
  items: IDmComponentsItem[];
  modelValue: IDmComponentsItem | null;
  name: string;
}

interface IDmRadioButtonEmits {
  (name: 'update:modelValue', item: IDmComponentsItem): void;
  (name: 'update:errors', e: any): void;
}

// data

export default /*#__PURE__*/_defineComponent({
  props: {
    items: { type: Array, required: true },
    modelValue: { type: [Object, null], required: true },
    name: { type: String, required: true }
  },
  emits: ["update:modelValue", "update:errors"],
  setup(__props: any, { emit: emits }: { emit: ({
  (name: 'update:modelValue', item: IDmComponentsItem): void;
  (name: 'update:errors', e: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  items: IDmComponentsItem[];
  modelValue: IDmComponentsItem | null;
  name: string;
}
const error: Ref<boolean> = ref(false);

// emits


// props


// watch
watch(() => error.value, (val) => {
  emits('update:errors', val);
});


// methods 
const select = (item: IDmComponentsItem) => {
  error.value = false;
  emits('update:modelValue', item);
};

const validate = (e: any) => {
  error.value = true;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["radio-buttons", { 'radio-buttons--error': error.value }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("input", {
            class: "radio-button__input",
            type: "radio",
            id: `${__props.name}-${item.key}`,
            value: __props.modelValue?.key,
            onKeyup: _withKeys(($event: any) => (select(item)), ["enter"]),
            onClick: ($event: any) => (select(item)),
            checked: __props.modelValue?.key === item.key,
            required: !index,
            onInvalid: validate,
            name: __props.name
          }, null, 40, _hoisted_2),
          _createElementVNode("label", {
            class: "radio-button__label",
            for: `${__props.name}-${item.key}`
          }, _toDisplayString(item.text), 9, _hoisted_3)
        ]))
      }), 256))
    ], 2),
    _withDirectives(_createElementVNode("p", _hoisted_4, "Wybierz jedną z opcji", 512), [
      [_vShow, error.value]
    ])
  ], 64))
}
}

})